'use strict'

import React from 'react'

export default class YourSummary extends React.Component {
  lastPage (e) {
    e.preventDefault()
    this.props.lastPage()
  }

  render () {
    const { summary } = this.props

    return (
      <div className='your-summary'>
        <section>
          <h2>Your Summary</h2>
          <ul>
            {Object.keys(summary).map((key) => {
              let val = summary[key]
              if (!val.displayName || !val.displayInSummary) return
              return (
                <li key={key}>
                  <span className='summary-title'>
                    {val.displayName}:&nbsp;
                  </span>
                  <span className='summary-value'>
                    {typeof val.value === 'string' ? val.value : val.value.join(', ')}
                  </span>
                </li>
              )
            })}
          </ul>
          <a className='summary-edit' href='' onClick={this.lastPage.bind(this)}>edit</a>
        </section>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/assets/your-summary.js